import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "export-order-modal__content-container" }
const _hoisted_2 = { class: "export-order-modal__header" }
const _hoisted_3 = { class: "export-order-modal__main-content main-content" }
const _hoisted_4 = { class: "main-content__select-format select-format" }
const _hoisted_5 = { class: "select-format__label" }
const _hoisted_6 = { class: "export-order-modal__footer footer" }

import { i18n } from '@/i18n';
import Modal from '@/components/modal/Modal.vue';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { watch } from 'vue';
import { useRegisterOrderModalStore } from './useRegisterOrderModalStore';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'RegisterOrderModal',
  props: {
    modalState: { type: Boolean, default: false }
  },
  emits: ["closeModal", "exportOrder"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// emits
const emits = __emit;

//変数
const t = i18n.t;

const store = useRegisterOrderModalStore();
const { state } = storeToRefs(store);

watch(
  () => props.modalState,
  () => {
    if (!props.modalState) {
      store.$reset();
    }
  }
);

/**
 * 出力ボタンのdisabled判定
 */
const isDisabledExportButton = computed(() => {
  return state.value.selectedFile === undefined;
});

/**
 * ファイル選択ボタン押下
 */
const onClickSelectFileButton = () => {
  // ファイル選択を発火させる
  document.getElementById('file-input')?.click();
};

/**
 * ファイル選択時の処理
 * @param event - イベント
 */
const handleFileChange = (event: Event) => {
  if (!(event.target instanceof HTMLInputElement)) return;
  const file = event.target.files?.[0];
  if (!file) return;
  state.value.selectedFile = file;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    class: "export-order-modal",
    "modal-size": 400,
    "stretch-container": true,
    "scroll-off": true,
    padding: '24px 32px',
    "modal-state": _ctx.modalState,
    "border-radius": '16px',
    onOutsideClick: _cache[3] || (_cache[3] = ($event: any) => (emits('closeModal')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('発注の取込')), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('エクセルを選択してください')), 1),
            _createVNode(TextButton, {
              "button-style": 'btn-primary',
              size: 'btn-md',
              "on-click": onClickSelectFileButton,
              disabled: false,
              class: "select-format__select-file-button"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('取込ファイル＋')), 1)
              ], undefined, true),
              _: 1
            }),
            _createElementVNode("input", {
              id: "file-input",
              class: "select-format__file-input",
              type: "file",
              onChange: _cache[0] || (_cache[0] = ($event: any) => (handleFileChange($event)))
            }, null, 32)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(TextButton, {
            class: "footer__button footer__button--cancel",
            onClick: _cache[1] || (_cache[1] = () => emits('closeModal'))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('もどる')), 1)
            ], undefined, true),
            _: 1
          }),
          _createVNode(TextButton, {
            class: "footer__button footer__button--confirm",
            disabled: isDisabledExportButton.value,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (emits('exportOrder', _unref(state).selectedFile)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('取込')), 1)
            ], undefined, true),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ], undefined, true),
    _: 1
  }, 8, ["modal-state"]))
}
}

})